import router from '../router'
import VueTk from '@moke/vue-tk'
import store from '@/store'
const rulers = [{
  match: '*',
  except: [
    '/user/login',
    '/exception/403',
    '/exception/404'
  ],
  handler: async function (route, next) {
    // 判断路由是否有权访问
    if (!!store.state.user && !!store.state.sessionToken) {
      let routArr = ['/', '/model/InformationPosts', '/account/setting/base', '/account/setting/editPassWord', '/setting', '/model/user', '/model/applicationRecord',
        '/model/changeAccountRecord', '/model/oneIfication', '/model/classIfication',
        '/model/commodityList', '/model/order', '/model/orderEvaluation', '/model/returnExchangeRecords',
        '/model/couponIssues', '/model/postType', '/model/authorizeAccount', '/model/turntableSettings',
        '/model/drawRecords', '/model/luckyStarRecords', '/model/happyBeanRecords', '/model/buyRecommendation',
        '/model/excellentCases', '/model/news', '/model/messageNotification', '/model/importantNotice',
        '/model/downloadImage', '/model/downloadVideo', '/model/downloadAudio', '/model/downloadFile',
        '/model/feedBack', '/model/popularSearch', '/model/kingKongDistrict', '/model/bannerImage', '/model/themeBackground',
        '/model/brandSpecial', '/model/commonProblem', '/model/coupons', '/model/freightVouchers']
      let status = routArr.some(s => s === route.path)
      if (!status) {
        next('/exception/404')
      } else {
        next(true)
      }
    } else {
      next('/user/login')
    }
  },
  fallbackUrl: '/exception/404'
}]

VueTk.tkRouterAuth.init(rulers, router)
